import { GlobalStyles } from './globalStyles';
import { theme, themeDesktop } from './theme';

const styles = {
  GlobalStyles,
  theme,
  themeDesktop,
};

export default styles;
